import React, { Component } from "react";
import { getImgInSize } from "../../util";
import "./index.css";

class OptimizedImg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failedToLoad: false,
    };
    this.handleError = this.handleError.bind(this);
  }

  handleError(e) {
    this.setState({ failedToLoad: true });
  }
  render() {
    let { size, url, alt = "optimized image", ...rest } = this.props;
    let { failedToLoad } = this.state;

    return (
      <img
        src={failedToLoad ? url : getImgInSize(url, size)}
        alt={alt}
        {...rest}
        onError={this.handleError.bind(this)}
      />
    );
  }
}

export default OptimizedImg;



// WEBPACK FOOTER //
// ./src/components/OptimizedImg/index.js